var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 94
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.294
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E4002B",
    d: "M47.93 39.488H95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7D7D87",
    d: "M56.488 52.432v19.25H32.953"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7D7D87",
    d: "m3 3 29.953 19.317V91L3 71.683zh53.488v23.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E4002B",
    d: "M77.884 22.317 95 39.487 77.884 56.66"
  }))));
};
export default SvgLogout;